<template>
    <div class="single">
        <div class="head">
            <i class="back"
               @click="back()"></i>
            <p class="title">第{{title}}题</p>
        </div>
        <template v-if="loading">
            <div class="content ensync_work_cont">
                <div class="topic">
                    <!-- 一题多问的大题干 -->
                    <div class="title"
                         v-if="topic.asks.length>1">
                        <p v-html="topic.subject.title"
                           v-if="topic.subject.title"></p>
                        <p :class="{'topic-con':topic.subject.title}"
                           v-html="topic.subject.content"
                           v-if="topic.subject.content"></p>
                    </div>
                    <!-- 一题多问的大题题干图片 -->
                    <template v-if="topic.asks.length>1&&topic.subject&&topic.subject.images">
                        <div class="cont_img"
                             v-for=" (img) in topic.subject.images ">
                            <img :src="img"
                                 alt="" />
                        </div>
                    </template>
                    <div v-if="topic.listen_audio">
                        <audio-component :ask="topic"
                                         :sid="sid"></audio-component>
                    </div>
                    <!-- 分一题一问和一题多问主要是为了添加错号对号 -->
                    <template v-for="(ask,askInd) in topic.asks">
                        <div class="ask">
                            <!-- 一题一问的题干 -->
                            <div class="title"
                                 v-if="topic.asks.length===1">
                                <p v-html="topic.subject.title"
                                   v-if="topic.subject.title"></p>
                                <p :class="{'topic-con':topic.subject.title}"
                                   v-html="topic.subject.content"
                                   v-if="topic.subject.content"></p>
                            </div>
                            <!-- 一题一问的题干图片 -->
                            <template v-if="topic.asks.length===1">
                                <div class="cont_img"
                                     v-for=" (img) in topic.subject.images ">
                                    <img :src="img"
                                         alt="" />
                                </div>
                            </template>
                            <!-- 如果是听力，加上听力条 -->
                            <div class="audio"
                                 v-if="ask.listen_audio">
                                <audio-component :ask='ask'
                                                 :sid="sid"></audio-component>
                            </div>

                            <!-- 选择题、听力题、完形填空、阅读理解 -->
                            <div v-if="topic.type===1||topic.type===3||topic.type===4||topic.type===5||topic.type===6||topic.type===7||topic.type===8||(sid==92&&topic.type===1)||(sid==92&&topic.type===2)||(sid==92&&topic.type===4)">
                                <choose-component :ask="ask"
                                                  :type="topic.type"
                                                  :isAudio="ask.listen_audio"
                                                  :mystatus="1"></choose-component>
                            </div>
                            <!-- 填空题 -->
                            <div v-else-if="topic.type === 9">
                                <fill-component :ask="ask"></fill-component>
                            </div>
                            <!-- 连线题 -->
                            <div v-else-if="topic.type === 2">
                                <line-component :ask="ask"
                                                :onlyshow="true"
                                                :sheet="ask.answer"></line-component>
                            </div>
                            <!-- 连词成句、连句成段 -->
                            <div v-else-if="topic.type===10||topic.type===11">
                                <make-component :ask="ask"
                                                :is_answer="true"
                                                :type="topic.type"></make-component>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
            <div class="bottom">
                <h3>答错{{stu_list.length}}人</h3>
                <!--<h3 class="border0" v-else>全答对了</h3>-->
                <ul class="stu clearfix">
                    <li :class="{'margin0':(stuI+1)%4===0}"
                        v-for="(stu,stuI) in stu_list">{{stu.real_name}}</li>
                </ul>
            </div>
        </template>
        <loading-s v-else></loading-s>
    </div>
</template>

<script type="text/ecmascript-6">
import loadingS from 'COMPONENTS/base/tealoading.vue';
import chooseComponent from 'VIEWS/english/module/result_choose.vue';   //选择题
import fillComponent from 'VIEWS/english/module/result_fill.vue';   //填空题
import lineComponent from 'VIEWS/english/module/line.vue';   //连线题
import makeComponent from 'VIEWS/english/module/result_make.vue';   //连词成句、连句成段题
import audioComponent from 'VIEWS/english/module/result_audio.vue';  //听力进度条
// import audioComponent from 'SRC/components/english/module/tea/audio.vue';  //听力进度条
export default {
    data () {
        return {
            message_id: this.$route.params.message_id,
            sid: this.$route.params.sid,
            qid: this.$route.params.qid,
            title: this.$route.query.title,
            unit_class_id: this.$route.query.classId,
            stu_list: [],
            topic: [],
            loading: false
        }
    },
    components: {
        loadingS, chooseComponent, fillComponent, lineComponent, makeComponent, audioComponent
    },
    methods: {},
    async created () {
        await this.$http.post(API_URL_TASK_API + '/english/check/single', {
            message_id: this.message_id,
            sid: this.sid,
            qid: this.qid,
            unit_class_id: this.unit_class_id,
        }).then(res => {
            res = res.data;
            if (res.response === 'ok') {
                this.topic = res.data.q_data[0];
                this.stu_list = res.data.stu_info;
                this.loading = true;
            }
        })
    }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "./src/assets/scss/common/_mixin";

.single {
    min-height: 100vh;
    padding-top: 96px/$ppr;
    .head {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10;
    width: 100vw;
    height: 96px / $ppr;
    background: #5e89ef;

    .back {
        position: absolute;
        top: 0;
        left: 0;
        width: 76px / $ppr;
        height: 96px / $ppr;
        background: url(./img/choose_back.png) no-repeat center;
        background-size: 18px / $ppr 34px / $ppr;
    }

    .title {
        width: 100%;
        height: 96px / $ppr;
        line-height: 96px / $ppr;
        font-size: 34px / $ppr;
        color: #fff;
        text-align: center;
    }

    .preview {
        position: absolute;
        top: 0;
        height: 96px / $ppr;
        line-height: 96px / $ppr;
        right: 24px / $ppr;
        z-index: 10;
        font-size: 30px / $ppr;
        color: #fff;
    }
}
    .content {
        font-family: Monospace;
        margin-bottom: 24px / $ppr;
        font-size: 30px / $ppr;
        color: #333;
        .topic {
            background: #fff;
            .title {
                p {
                    padding: 34px / $ppr 24px / $ppr;
                    &.topic-con {
                        border-top: 1px / $ppr solid #e8e8e8;
                    }
                }
            }
            .ask {
                .audio {
                    position: relative;
                    padding: 0 24px / $ppr;
                    height: 96px / $ppr;
                    line-height: 96px / $ppr;
                    background-color: #f6f6f6;
                    box-sizing: border-box;
                }
            }
        }
    }
    .bottom {
        margin-top: 24px / $ppr;
        background: #fff;
        h3 {
            padding: 0 24px / $ppr;
            height: 96px / $ppr;
            line-height: 96px / $ppr;
            font-size: 36px / $ppr;
            font-weight: bold;
            color: #333;
            border-bottom: 1px / $ppr solid #e8e8e8;
            &.border0 {
                border-bottom: none;
            }
        }
        .stu {
            padding: 32px / $ppr 24px / $ppr;
            li {
                float: left;
                width: 130px / $ppr;
                margin-right: 50px / $ppr;
                text-align: center;
                font-size: 30px / $ppr;
                color: #333;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                &.margin0 {
                    margin-right: 0;
                }
            }
        }
    }
}
</style>
